export const Version1CollaborationId = '1';
